import React from 'react'
import styles from './styles.module.css'

function Location ({ record }) {
  return (
    <section style={{ display: 'flex', gap: '72px', marginBottom: '24px' }}>
      <div className={styles.containersLocationPeople}>
        <span className={styles.spanLocationPeople}>Address</span>
        <span className={styles.spanRecordLocationPeople}>
          {record?.address || 'N/A'}
        </span>
      </div>

      <div className={styles.containersLocationPeople}>
        <span className={styles.spanLocationPeople}>City</span>
        <span className={styles.spanRecordLocationPeople}>
          {record?.city || 'N/A'}
        </span>
      </div>

      <div className={styles.containersLocationPeople}>
        <span className={styles.spanLocationPeople}>State</span>
        <span className={styles.spanRecordLocationPeople}>
          {record?.province || 'N/A'}
        </span>
      </div>

      <div className={styles.containersLocationPeople}>
        <span className={styles.spanLocationPeople}>Postal code</span>
        <span className={styles.spanRecordLocationPeople}>
          {record?.postalCode || 'N/A'}
        </span>
      </div>

      <div className={styles.containersLocationPeople}>
        <span className={styles.spanLocationPeople}>Country</span>
        <span className={styles.spanRecordLocationPeople}>
          {record?.country || 'N/A'}
        </span>
      </div>
    </section>
  )
}

export default Location
